import axios from 'axios';

const baseURL = import.meta.env.VITE_APP_API_BASE_URL;
console.log('Base API URL:', baseURL);


const axiosInstance = axios.create({
  baseURL: baseURL || 'http://localhost:2222/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use((config) => {
 // console.log('Request URL:', config);
  return config;
});

export default axiosInstance;
